import React from 'react';

import { Listing } from '@klokhuis/core/ApiClient/Klokhuis';
import { CardRail } from '@klokhuis/core/Components/CardRail';
import { useListingSelectors } from '@klokhuis/modules/Properties/context/hooks/useListingSelectors';
import { CommonStyles } from '@klokhuis/styles/CommonStyles';
import { useMediaIsDesktop } from '@klokhuis/utilities/Media/useMediaIsDesktop';

import { ListingCard } from '../ListingCard';
import ListingCardSkeleton from '../ListingCard/ListingCardSkeleton';

interface CarouselGeneratorProps {
  listings: Array<Listing>;
}

const CarouselGeneratorInternal = ({ listings }: CarouselGeneratorProps) => {
  const isLoading = useListingSelectors().isLoading();
  const isDesktop = useMediaIsDesktop();
  const visibleItemsCount = 3;

  const skeletons = Array(visibleItemsCount).fill(0);

  return (
    <div className={CommonStyles.margin_bottom_3}>
      <CardRail visibleItemsCount={isDesktop ? visibleItemsCount : 1}>
        {isLoading
          ? skeletons.map((_, index) => {
              const uniqueKey = `skeleton-${index}`;
              return <ListingCardSkeleton key={uniqueKey} />;
            })
          : listings.map(listing => (
              <ListingCard
                key={listing.listingId}
                listingId={listing.listingId}
                thumbnailUrl={listing.thumbnailUrl}
                fullPreviewImageUrl={listing.thumbnailUrl}
                isTopAdvert={Boolean(listing.isTopAdvert)}
                streetName={listing.cityName?.toString() || ''}
                cityName={listing.cityName?.toString() || ''}
                areaOrLandmark={listing.areaOrLandmark || undefined}
                isFavorite={Boolean(listing.isActive)}
                plotArea={listing.plotArea}
                listingType={listing.listingTypeId}
                salePrice={listing.salePrice}
                isPriceNegotiable={listing.isActive}
                listingStatus={listing.listingStatus}
                plotAreaUnit={listing.plotAreaUnit}
              />
            ))}
      </CardRail>
    </div>
  );
};

export const CarouselGenerator = React.memo(CarouselGeneratorInternal);
